import { get } from 'lodash-es';

import { emptyArray } from 'ui-components/default-props/empty';

export const selectOrderBatchIds = (state) => get(state, 'orderBatches', emptyArray);
export const selectShipmentBatchIds = (state) => get(state, 'shipmentBatches', emptyArray);
